import type { ReactNode } from "react";

import { HeadContent, Scripts } from "@tanstack/react-router";

import { FontPreloads } from "@/features/site-shell/media";

import "@softmax/design-tokens/tokens.css";
import "@softmax/design-system/global.css";
import "@/styles/fonts.css";
import "@/styles/global.css";

export function Document({ children }: { children: ReactNode }) {
  return (
    <html
      lang="en"
      className="site-fonts"
      data-softmax-theme="light"
      suppressHydrationWarning
    >
      <head>
        <FontPreloads group="site" />
        <HeadContent />
      </head>
      <body className="coworld-site">
        <a
          data-site-skip
          href="#main"
          className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[2147483001] focus:rounded-[3px] focus:border focus:border-foreground focus:bg-background focus:px-2.5 focus:py-1 focus:text-[12px] focus:text-foreground focus:no-underline focus:outline-2 focus:outline-offset-2 focus:outline-foreground"
        >
          Skip to main content
        </a>
        {children}
        <Scripts />
      </body>
    </html>
  );
}
